import BigNumber from 'bignumber.js';
import IMask from 'imask';

const amountInputTypes = {
  crypto: 'CRYPTO',
  fiat: 'FIAT',
};

export class CalculatorAmount {
  constructor (amountString, currency, type, maxDecimals) {
    this.setAmountString(amountString);
    this.currency = currency || null;
    this.type = type;
    this.maxDecimals = maxDecimals;
    this.activeInput = false;
    this.maskSettings = {
      mask: Number,
      scale: this.maxDecimals,
      signed: false,
      normalizeZeros: false,
      radix: '.',
      mapToRadix: ['.', ','],
    };
  }

  static createCryptoAmount (amountString, currency) {
    return new CalculatorAmount(amountString, currency, amountInputTypes.crypto, 8);
  }

  static createFiatAmount (amountString, currency) {
    return new CalculatorAmount(amountString, currency, amountInputTypes.fiat, 2);
  }

  activate () {
    this.activeInput = true;
  }

  deactivate () {
    this.activeInput = false;
  }

  isActive () {
    return this.activeInput;
  }

  setAmountNumber (bigNumber) {
    this.amount = bigNumber;
    
    const masked = IMask.createMask(this.maskSettings);
    masked.resolve(bigNumber.toString(10));

    this.amountString = masked.value;
  }

  setAmountString (amountString) {
    this.amountString = amountString;
    this.amount = new BigNumber(amountString);
  }

  setCurrency (currency) {
    this.currency = currency;
  }

  isCrypto () {
    return this.type === amountInputTypes.crypto;
  }

  isFiat () {
    return this.type === amountInputTypes.fiat;
  }
}
